module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_other-dbaa546075792c7b5d09f029094ec512.png";